import { render } from "./generateOrder.vue?vue&type=template&id=923e7314"
import script from "./generateOrder.vue?vue&type=script&lang=js"
export * from "./generateOrder.vue?vue&type=script&lang=js"
script.render = render

export default script